import { encryptBikData } from './encryption';

export enum LOCAL_STORAGE_KEYS {
  BIK_CHAT_WIDGET = 'bik-chat-widget',
  BIK_PHONE_NUMBER = 'bik-phone-number',
  BIK_EMAIL = 'bik-email',
  BIK_COUPON_DISBURSED = 'bik-coupon-disbursed',
}

export function storeObjectInLocalStorage(key: string, data: any) {
  try {
    if (!localStorage.getItem(key)) {
      const jsonData = JSON.stringify(data);
      localStorage.setItem(key, encryptBikData(jsonData));
    }
    return;
  } catch (error) {
    return;
  }
}

export function storeDataInLocalStorage(key: string, data: any) {
  try {
    if (!localStorage.getItem(key) && data) {
      localStorage.setItem(key, encryptBikData(data));
    }
    return;
  } catch (error) {
    return;
  }
}
